import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { Component, forwardRef } from "@angular/core";

import { MedOptionType } from "../types";
import { simpleCompare } from "../../../utils/base.util";
import { STRING } from "../../../constants/string";
import { SelectCoreComponent } from "../SelectCoreComponent";
import { DomUtil } from "../../../utils/dom.util";
import { KeyNames } from "../../../constants/key-names";

@Component({
  selector: "med-select",
  templateUrl: "./med-select.component.html",
  styleUrls: ["./med-select.component.scss"],
  providers: [{
    multi: true,
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => MedSelectComponent),
  }],
})
export class MedSelectComponent<OptionValueType> extends SelectCoreComponent<OptionValueType | string> {
  override itemSelector = ".med-select__list-item";
  get title(): string {
    const option = this.options.find(({ value }) => simpleCompare(value, this.value));
    return option ? option.label : this.placeholder || STRING.INVISIBLE;
  }

  onClear(event: Event): void {
    event.preventDefault();
    this.onToggle(false);
    this.value = STRING.EMPTY;
    this.onInput.emit(this.value);
  }

  onSelect({ value, disabled }: MedOptionType<OptionValueType>): void {
    if (this.disabled || disabled) {
      return;
    }

    this.value = value;
    this.onInput.emit(value);
    this.onToggle(false);
  }

  hasActive(value: OptionValueType): boolean {
    return simpleCompare(value, this.value);
  }

  override focusNextActiveOption(event: KeyboardEvent): void {
    if (event.target) {
      const nextFocusableItem: HTMLElement | null = this.findNextActiveOption(event.target, event);
      nextFocusableItem?.focus();
    }
  }

  override findNextActiveOption(item: any, event: KeyboardEvent): HTMLElement | null {
    const nextItem = event.key === KeyNames.ARROW_DOWN
      ? item.nextElementSibling
      : item.previousElementSibling;

    if (nextItem) {
      return DomUtil.hasClass(nextItem, "disabled")
        ? this.findNextActiveOption(nextItem, event)
        : nextItem;
    }

    return null;
  }
}
